
import _ from 'lodash'
//import moment from 'moment/moment'
import moment from 'moment';
/*
import 'moment-timezone';
*/
//import moment from 'moment-timezone'
//var moment = require('moment');
/*
import { timeHours } from 'd3-time';
*/

export default class SVGraphComponent  {

    constructor(){
        this.addToLong = this.addToLong.bind(this)
        this.changeUSDateWithBackward = this.changeUSDateWithBackward.bind(this)
        this.changeUSDateWithTime = this.changeUSDateWithTime.bind(this)
        this.toUSDateWithTime = this.toUSDateWithTime.bind(this)
        /*
        this.serializeData =this.serializeData.bind(timeHours)
        */
        this.graphPairs = this.graphPairs.bind(this)
       
        this.svDaysPercentOfYear = this.svDaysPercentOfYear.bind(this)
        this.toUSDate = this.toUSDate.bind(this)
        this.toUSDateWithTimeShort = this.toUSDateWithTimeShort.bind(this)
        
        this.getLongForDash = this.getLongForDash.bind(this)
      
        this.svDateLong = this.svDateLong.bind(this)
        this.svDateLongMs = this.svDateLongMs.bind(this)
        this.svDateLongReport = this.svDateLongReport.bind(this)
        this.svDateStockPlan = this.svDateStockPlan.bind(this)
        this.getTimeHistoryArrayFromToday = this.getTimeHistoryArrayFromToday.bind(this)
        this.svEpochRangeUTC = this.svEpochRangeUTC.bind(this)
        this.toStandardUSDate = this.toStandardUSDate.bind(this)
        this.svFindStartDateFromTodayBackward = this.svFindStartDateFromTodayBackward.bind(this)
        this.getMomentObject = this.getMomentObject.bind(this)
        this.svTodayDateTime = this.svTodayDateTime.bind(this)
        this.svDateGreaterMonth = this.svDateGreaterMonth.bind(this)
        this.svDateTimeFromBegining = this.svDateTimeFromBegining.bind(this)
        this.pad = this.pad.bind(this)
        this.padMs = this.padMs.bind(this)
        this.getMomentObjectDash = this.getMomentObjectDash.bind(this)
        this.getLongForDash = this.getLongForDash.bind(this)
        this.getMonthYear = this.getMonthYear.bind(this)
        this.addDeltaToLong = this.addDeltaToLong.bind(this)
        
        



    } 

/*
serializeData(ob) {

    var formData = '';

    angular.forEach(ob, function(v, k) {
        formData += k + '=' + v + '&';
    });

    formData = formData.substr(0, formData.length - 1);

    return formData;
    // body...
}
*/
graphPairs(ob, fld, ckField, peerField, peerFieldMax) {
    let component = this
    if (ob) {
        var parent = ob;
        if (!_.isDefined(parent[ckField])) {
            parent = {
                'in_use': 0,
                'limit': 100
            };
        }
        if (_.isDefined(parent[ckField]) && (parent[ckField] < 1)) {
            parent[peerField] = peerFieldMax;
        }

    }
    // body...
}

    getMomentObject(mmDDYYYY) {
        let component = this
        var time = {},
            tokens;
        tokens = mmDDYYYY.split('/');
        time.month = Number(tokens[0]);
        time.month = time.month - 1;
        time.day = Number(tokens[1]);
        time.year = Number(tokens[2]);
        return time;

    }
    svTodayDateTime(zone) {
        let component = this
        zone = zone || 'America/New_York';
        var aDate, endDate, endDay, endYear, from, currentMon, endMonth, lastDate;
        endDate = moment.tz(zone);
        endMonth = endDate.month();
        endDay = endDate.date();
        endYear = endDate.year();
        endMonth = endDate.month() + 1;
        if (endMonth < 10) {
            endMonth = '0' + endMonth;
        }
        lastDate = endMonth + '/' + endDay + '/' + endYear;
        return lastDate;

    }

    svDaysPercentOfYear(zone, roundTo) {
        let component = this
        roundTo = roundTo || 0;
        zone = zone || 'America/New_York';
        var aDate, endDate, remaining;
        endDate = moment.tz(zone);


        remaining = ((365 - endDate.dayOfYear()) / 365) * 100;
        return Number(remaining.toFixed(roundTo));



    }
    toUSDate(date, zone, dateSeparator) {
        let component = this
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';
        var time = moment.tz(date, zone);

        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        display = mon + dateSeparator + oaDay + dateSeparator + y;

        return display;

    };

    toUSDateWithTimeShort(date, zone, dateSeparator) {
        let component = this
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';
        var time = moment.tz(date, zone);
        var hh, mm, ss, ms;
        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();

        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        //mon = component.months[sub].abbr;
        if (dateSeparator == ',') {
            mon = component.months[mon].abbr;
            display = mon + dateSeparator + oaDay;

        } else {
            display = mon + dateSeparator + oaDay;

        }


        hh = this.pad(hh, 10);
        mm = this.pad(mm, 10);
        ss = this.pad(ss, 10);
        ms = this.padMs(ms, 1000);

        display += 'T' + hh + ':' + mm + ':' + ss;

        return display;

    }
    getMomentObjectDash(YYYYmmDD) {
        var time = {},
            tokens;
        tokens = YYYYmmDD.split('-');
        time.month = Number(tokens[1]);
        time.month = time.month - 1;
        time.day = Number(tokens[2]);
        time.year = Number(tokens[0]);
        return time;

    }

    getLongForDash(YYYYmmDD, hh, zone) {
        let component = this
        zone = zone || 'America/New_York';
        var mo = component.getMomentObjectDash(YYYYmmDD);
        var md = moment.tz(mo, zone);
        md.set('hour', 0);
        md.add('hour', hh);
        return md.valueOf();
    };


    getMonthYear(svd) {

        let component = this
        var s = svd.year(),
            m, sub, mon;

        m = svd.month();
        m = m + 1;
        if (m < 10) {
            sub = '0' + m;
        } else {
            sub = '' + m;
        }
        mon = component.months[sub].abbr;
        let info = mon + ' ' + s;
        s = info;
        return s;

    }
    svDateLong(mmDDYYYY, zone) {
        let component = this
        zone = zone || 'America/New_York';

        var slotMoment = component.getMomentObject(mmDDYYYY),
            slotDate = moment.tz(slotMoment, zone);
        return slotDate.valueOf();



    };

    svDateLongReport(weekDay, hh, zone) {
        let component = this
        let h = 0, dayName
        zone = zone || 'America/Los_Angeles';
        var aDate, fromDate, from, unDay;
        aDate = moment.tz(zone);

        var cnDay = aDate.weekday();
        //say cnDay =5

        unDay = component.dayName[dayName].n;

        aDate.second(0);
        aDate.minute(0);
        aDate.hour(h);
        aDate.milliseconds(0);
        let diff = Math.abs(cnDay - unDay);
        aDate.subtract('day', diff);


        return aDate.valueOf();



    };
    svDateLongMs(mmDDYYYY, zone) {
        let component = this
        zone = zone || 'America/New_York';

        var slotMoment = component.getMomentObject(mmDDYYYY),
            slotDate = moment.tz(slotMoment, zone);
        slotDate.hour(23);
        slotDate.minute(59);
        slotDate.second(59);
        return slotDate.valueOf();



    };
    //svapr2018
    svDateStockPlan(millisec, zone) {
        let component = this
        zone = zone || 'America/New_York';
        var spDate, mon, date;

        var svd = moment.tz(millisec, zone);
        mon = svd.month();
        mon++;
        if (mon < 10) {
            mon = '0' + mon;
        }
        date = svd.date();
        if (date < 10) {
            date = '0' + date;
        }


        return mon + '/' + date + '/' + svd.year();

    };


    //svfeb7..

    getTimeHistoryArrayFromToday (size) {

        let component = this

        var ms = component.svDateLongMs("05/10/2017"),
            dt;
        var ar = [{
            x: ms,
            y: 1000,
            date: "05/10/2017"
        }];

        for (var i = 0; i < size; i++) {

            ms -= 60 * 60 * 24 * 1000;
            dt = component.svDateStockPlan(ms);
            ar.push({
                x: ms,
                y: 100000,
                date: dt
            });



        }


        return ar;

    }


    svEpochRangeUTC(size, fromDate, filter, zone) {
        let component = this
        zone = zone || 'America/New_York';
        var aDate, endDate, endDay, endYear, from, currentMon, endMonth, lastDate, positions = [],
            ms;
        filter = filter + 1;
        if (fromDate) {
            from = this.getMomentObject(fromDate);
            from.day = 1;
            aDate = moment.tz(from, zone);
        } else {
            aDate = moment.tz(zone);
        }

        for (var i = 0; i < filter; i++) {
            ms = Date.UTC(aDate.year(), aDate.month(), aDate.date());
            positions.push(ms);

            aDate.add('months', size);


        }

        return positions;



    }


    toStandardUSDate(chartTimeInfo, zone, dateSeparator) {
        let component = this

        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';

        var chartTime = _.copy(chartTimeInfo);
        if (chartTime.month > 0) {
            chartTime.month = Number(chartTime.month);

        }



        var oaDay = chartTime.day,
            oaMonth = chartTime.month,
            y = chartTime.year,
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = oaMonth;
        } else {
            mon = oaMonth;
        }

        display = mon + dateSeparator + oaDay + dateSeparator + y;

        return display;

    };




    svFindStartDateFromTodayBackward(zone) {
        let component = this
        zone = zone || 'America/New_York';
        var aDate, fromDate, from;
        aDate = moment.tz(zone);

        aDate.add('months', 1);
        aDate.set('date', 1);

        aDate.subtract('months', 6);
        from = aDate.valueOf();
       // fromDate = $graphComponent.svDateStockPlan(from);
        fromDate = "12/11/2014"
        return fromDate;



       // svEpochRangeUTC(1, fromDate, 6);

    };

    svDateGreaterMonth = function(slot, mmYYYY, zone) {
        let component = this

        zone = zone || 'America/New_York';
        var greaterThanStart = true;
        var tokens = mmYYYY.split(' ');
        var tm = tokens[0];
        var ty = tokens[1];
        var mo = component.months;
        var svo = _.findKey(mo, function(v) {

            return (v.abbr.toLocaleUpperCase() == tm.toLocaleUpperCase() ? true : false);
        });

        let start = svo + '/' + '01' + '/' + ty;

        var belongs = false,
            slotDate,
            a, b, ba, bb, aDate = component.getMomentObject(start),

            slotMoment = component.getMomentObject(slot);
        a = _.copy(aDate);
        ba = moment.tz(a, zone);
        slotDate = moment.tz(slotMoment, zone);

        if (greaterThanStart === true) {
            if ((slotDate.diff(ba) > 0)) {
                belongs = true;

            }


        }
        return belongs;

    }

    svDateTimeFromBegining (mmDDYYYY, zone) {
        var component = this
        zone = zone || 'America/New_York';
        var aDate, slotMoment, endDate, endDay, endYear, from, currentMon, endMonth, lastDate;


        slotMoment = component.getMomentObject(mmDDYYYY);
        endDate = moment.tz(slotMoment, zone);


        endMonth = endDate.month();
        endDay = 1;

        endYear = endDate.year();
        endMonth = endDate.month() + 1;
        if (endMonth < 10) {
            endMonth = '0' + endMonth;
        }
        lastDate = endMonth + '/' + endDay + '/' + endYear;

        return lastDate;

    };


    pad(n, floor) {

        var mon;
        if (_.isNumber(n) && n < floor) {
            mon = '0' + n;
        } else {
            mon = n;
        }

        return mon;

    };

    padMs(n, floor) {

        var mon;
        if (_.isNumber(n) && n < 10) {
            mon = '00' + n;

        } else if (_.isNumber(n) && n < 100) {
            mon = '0' + n;
        } else {
            mon = n;
        }

        return mon;

    };
    toUSDateWithTimeShort(date, zone, dateSeparator) {
        let component = this
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';
        var time = moment.tz(date, zone);
        var hh, mm, ss, ms;
        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();

        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        //mon = component.months[sub].abbr;
        if (dateSeparator == ',') {
            mon = component.months[mon].abbr;
            display = mon + dateSeparator + oaDay;

        } else {
            display = mon + dateSeparator + oaDay;

        }


        hh = this.pad(hh, 10);
        mm = this.pad(mm, 10);
        ss = this.pad(ss, 10);
        ms = this.padMs(ms, 1000);

        display += 'T' + hh + ':' + mm + ':' + ss;

        return display;

    };
    toAWSObject(date, zone, dateSeparator) {
        var me = this
        let diff , h 
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';
        var time = moment.tz(date, zone);
        var hh, mm, ss, ms, timeToken;
        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();



        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';


        timeToken = {
            "hh": hh,
            "mm": mm,
            "ss": ss,
            "year": y,
            "month": oaMonth,
            "day": oaDay

        };

        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        //mon = component.months[sub].abbr;
        if (dateSeparator == ',') {
            mon = this.component.months[mon].abbr;
            display = mon + dateSeparator + oaDay + ' ' + y;

        } else {
            display = mon + dateSeparator + oaDay + dateSeparator + y;

        }


        hh = this.this.pad(hh, 10);
        mm = this.this.pad(mm, 10);
        ss = this.this.pad(ss, 10);
        ms = this.this.padMs(ms, 1000);

        display += 'T' + hh + ':' + mm + ':' + ss + '.' + ms + 'Z';

        timeToken.display = display;

        return timeToken;

    }


    months = {
        '01': {
            name: 'January',
            abbr: 'Jan'
        },
        '02': {
            name: 'February',
            abbr: 'Feb'
        },
        '03': {
            name: 'March',
            abbr: 'Mar'
        },
        '04': {
            name: 'April',
            abbr: 'Apr'
        },
        '05': {
            name: 'May',
            abbr: 'May'
        },
        '06': {
            name: 'June',
            abbr: 'Jun'
        },
        '07': {
            name: 'July',
            abbr: 'Jul'
        },
        '08': {
            name: 'August',
            abbr: 'Aug'
        },
        '09': {
            name: 'September',
            abbr: 'Sep'
        },

        '10': {
            name: 'October',
            abbr: 'Oct'
        },
        '11': {
            name: 'November',
            abbr: 'Nov'
        },

        '12': {
            name: 'December',
            abbr: 'Dec'
        }
    };

    dayName = {
        'Sunday': {
            n: 0

        },

        'Monday': {
            n: 1

        },
        'Tuesday': {
            n: 2

        },
        'Wednesday': {
            n: 3

        },
        'Thursday': {
            n: 4

        },
        'Friday': {
            n: 5

        },
        'Saturday': {
            n: 6

        }
    }

    standardMonths = {
        '00': {
            name: 'January',
            abbr: 'Jan'
        },
        '01': {
            name: 'February',
            abbr: 'Feb'
        },
        '02': {
            name: 'March',
            abbr: 'Mar'
        },
        '03': {
            name: 'April',
            abbr: 'Apr'
        },
        '04': {
            name: 'May',
            abbr: 'May'
        },
        '05': {
            name: 'June',
            abbr: 'Jun'
        },
        '06': {
            name: 'July',
            abbr: 'Jul'
        },
        '07': {
            name: 'August',
            abbr: 'Aug'
        },
        '08': {
            name: 'September',
            abbr: 'Sep'
        },

        '09': {
            name: 'October',
            abbr: 'Oct'
        },
        '10': {
            name: 'November',
            abbr: 'Nov'
        },

        '11': {
            name: 'December',
            abbr: 'Dec'
        }
    }

    encodeAsQueryParams (ob) {

        var formData = '?';


        _.each(ob, function(v, k) {

            var innerob = v;
            if (typeof(innerob) === 'object') {
                _.each(innerob, function(iv, ik) {
                    formData = formData + (ik + '=' + iv + '&');

                });

            } else {
                formData = formData + (k + '=' + v + '&');

            }

        });




        return formData;
        // body...
    }
    encodeAsQueryParamsString(ob) {
       // var data = toJson(ob);
       var data = JSON.stringify(ob);



        return data;
    }

    addToLong(svpInterval, svpUnit, date, zone) {

        var hh, mm, ss, ms, time, delta = 1;
        zone = zone || 'America/New_York';



        // var date = cmpOb.startLong;
        time = moment.tz(date, zone);



        //time.add('minute', )


        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();

        if (svpUnit == 'min') {
            time.add('minute', (delta * svpInterval));
        } else if (svpUnit == 'sec') {

            time.add('second', (delta * svpInterval));
        } else if (svpUnit == 'hour') {

            time.add('hour', (delta * svpInterval));

        } else {
            time.add('minute', (delta * svpInterval));

        }

        return time;



    }

    subtractFromTodayLong(svpInterval, svpUnit, date, zone) {
        var me = this
        var hh, mm, ss, ms, time, delta = -1;
        zone = zone || 'America/New_York';



        // var date = cmpOb.startLong;
        if (date) {
            time = moment.tz(date, zone);

        } else {
            time = moment.tz(zone);

        }



        //time.add('minute', )


        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();

        if (svpUnit == 'min') {
            time.add('minute', (delta * svpInterval));
        } else if (svpUnit == 'sec') {

            time.add('second', (delta * svpInterval));
        } else if (svpUnit == 'hour') {

            time.add('hour', (delta * svpInterval));
        } else if (svpUnit == 'day') {

            time.add('days', (delta * svpInterval));
        } else if (svpUnit == 'month') {

            time.add('months', (delta * svpInterval));

        } else {
            time.add('minute', (delta * svpInterval));

        }

        return time;



    }

    changeUSDateWithBackward(cmpOb, spanOb, date, zone, dateSeparator) {
        var me = this
        /*

        spanOb={

            amount:1,
                 unit:'hour',
                 endDateDifference:15,
                  endDateDifferenceUnit:'min',
           
        },
        cmpOb ={
                                startLong:1504626500195,
                                endLong:1504804212000,
                                svpInterval:15,
                                svpUnit:'min',
                                startUtc:'',
                                endUtc:'',

                             }
        */

        var hh, mm, ss, ms, time;
        var backwardTime = spanOb.amount,
            backwardUnit = spanOb.unit;
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';


        //var time = moment.tz(date, zone);
        var svpUnit = cmpOb.svpUnit;
        var svpInterval = cmpOb.svpInterval;

        //time.add('minute', )



        time = me.subtractFromTodayLong(backwardTime, backwardUnit, date, zone);
        cmpOb.startLong = time.valueOf();

        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();




        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        hh = this.this.pad(hh, 10);
        mm = this.this.pad(mm, 10);
        ss = this.this.pad(ss, 10);
        ms = this.this.padMs(ms, 1000);

        display = mon + dateSeparator + oaDay + dateSeparator + y;

        display += 'T' + hh + ':' + mm + ':' + ss + '.' + ms + 'Z';
        cmpOb.startUtc = display;

        //end date
        date = cmpOb.endLong;
        time = me.addToLong(spanOb.endDateDifference, spanOb.endDateDifferenceUnit, time, zone);

        cmpOb.endLong = time.valueOf();

        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();




        oaDay = time.date();
        oaMonth = time.month() + 1;
        y = time.year();
        display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        hh = this.this.pad(hh, 10);
        mm = this.this.pad(mm, 10);
        ss = this.this.pad(ss, 10);
        ms = this.this.padMs(ms, 1000);

        display = mon + dateSeparator + oaDay + dateSeparator + y;

        display += 'T' + hh + ':' + mm + ':' + ss + '.' + ms + 'Z';
        cmpOb.endUtc = display;


    }
    toUSDateWithTime(date, zone, dateSeparator) {
        let component = this
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';
        var time = moment.tz(date, zone);
        var hh, mm, ss, ms;
        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();

        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        //mon = component.months[sub].abbr;
        if (dateSeparator == ',') {
            mon = component.months[mon].abbr;
            display = mon + dateSeparator + oaDay + ' ' + y;

        } else {
            display = mon + dateSeparator + oaDay + dateSeparator + y;

        }


        hh = this.pad(hh, 10);
        mm = this.pad(mm, 10);
        ss = this.pad(ss, 10);
        ms = this.padMs(ms, 1000);

        display += 'T' + hh + ':' + mm + ':' + ss + '.' + ms + 'Z';

        return display;

    }

    addDeltaToLong(date, delta, svpUnit, svpInterval, zone) {

        let component = this

        var hh, mm, ss, ms;
        zone = zone || 'America/New_York';



        // var date = cmpOb.startLong;
        var time = moment.tz(date, zone);


        //time.add('minute', )


        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();

        if (svpUnit == 'min') {
            time.add('minute', (delta * svpInterval));
        } else if (svpUnit == 'sec') {

            time.add('second', (delta * svpInterval));
        } else if (svpUnit == 'hour') {

            time.add('hour', (delta * svpInterval));

        } else {
            time.add('minute', (delta * svpInterval));

        }

        return time;



    }



    changeUSDateWithTime (cmpOb, delta, zone, dateSeparator) {
        var component = this

        /*
        svtimeRange:{
                                startLong:1504626500195,
                                endLong:1504804212000,
                                svpInterval:15,
                                svpUnit:'min',
                                startUtc:'',
                                endUtc:'',

                             }
        */
        var hh, mm, ss, ms;
        zone = zone || 'America/New_York';
        dateSeparator = dateSeparator || '/';

        var date = cmpOb.startLong;
        //var time = moment.tz(date, zone);
        var svpUnit = cmpOb.svpUnit;
        var svpInterval = cmpOb.svpInterval;

        //time.add('minute', )



        /*
                 if(cmpOb.svpUnit =='min' ){
                        time.add('minute',(delta * cmpOb.svpInterval));
                 }else if(cmpOb.svpUnit =='sec' ){

                     time.add('second',(delta * cmpOb.svpInterval));
                 }else if(cmpOb.svpUnit =='hour' ){

                     time.add('hour',(delta * cmpOb.svpInterval));    

                 }else{
                     time.add('minute',(delta * cmpOb.svpInterval));

                 }

                */

        var time = component.addDeltaToLong(date, delta, svpUnit, svpInterval, zone);
        cmpOb.startLong = time.valueOf();

        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();




        var oaDay = time.date(),
            oaMonth = time.month() + 1,
            y = time.year(),
            mon, display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        hh = this.pad(hh, 10);
        mm = this.pad(mm, 10);
        ss = this.pad(ss, 10);
        ms = this.padMs(ms, 1000);

        display = mon + dateSeparator + oaDay + dateSeparator + y;

        display += 'T' + hh + ':' + mm + ':' + ss + '.' + ms + 'Z';
        cmpOb.startUtc = display;

        //end date
        date = cmpOb.endLong;
        time = component.addDeltaToLong(date, delta, svpUnit, svpInterval, zone);
        cmpOb.endLong = time.valueOf();

        hh = time.hour();
        mm = time.minute();
        ss = time.second();
        ms = time.millisecond();




        oaDay = time.date();
        oaMonth = time.month() + 1;
        y = time.year();
        display = '';



        if (_.isNumber(oaMonth) && oaMonth < 10) {
            mon = '0' + oaMonth;
        } else {
            mon = oaMonth;
        }

        hh = this.pad(hh, 10);
        mm = this.pad(mm, 10);
        ss = this.pad(ss, 10);
        ms = this.padMs(ms, 1000);

        display = mon + dateSeparator + oaDay + dateSeparator + y;

        display += 'T' + hh + ':' + mm + ':' + ss + '.' + ms + 'Z';
        cmpOb.endUtc = display;


    };


}